var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.582,
    height: 24,
    viewBox: "0 0 20.582 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "External_Projects_Reports",
    "data-name": "External Projects Reports",
    transform: "translate(-38 -0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_170_",
    d: "M345.511,70.051h2.438L345,67.2v2.405A.5.5,0,0,0,345.511,70.051Z",
    transform: "translate(-292.607 -63.954)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_174_",
    d: "M91.029,46.1a2.357,2.357,0,0,1-2.386-2.325V40.128L78.488,40.1a.493.493,0,0,0-.488.469V59.876a.524.524,0,0,0,.511.478H94.4a.452.452,0,0,0,.427-.478V46.1Zm-1.683,3.7a.938.938,0,0,1,0,1.875h-8.2a.938.938,0,0,1,0-1.875ZM81.094,46.05h5.439a.938.938,0,0,1,0,1.875H81.094a.938.938,0,0,1,0-1.875Zm10.6,9.377H81.141a.938.938,0,0,1,0-1.875H91.69a.938.938,0,0,1,0,1.875Z",
    transform: "translate(-38.125 -38.125)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_488_",
    d: "M58.123,6.181,52.417.658a1.884,1.884,0,0,0-1.308-.53L40.363.1A2.355,2.355,0,0,0,38,2.444V21.751A2.4,2.4,0,0,0,40.386,24.1H56.28a2.329,2.329,0,0,0,2.3-2.354V7.3A1.542,1.542,0,0,0,58.123,6.181ZM52.393,3.246,55.342,6.1H52.9a.5.5,0,0,1-.511-.45ZM56.28,22.225H40.386a.52.52,0,0,1-.511-.478V2.444a.493.493,0,0,1,.488-.469L50.518,2V5.646A2.36,2.36,0,0,0,52.9,7.972h3.8V21.746A.452.452,0,0,1,56.28,22.225Z",
    transform: "translate(0 0)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Projects_Donation_History",
    "data-name": "Projects Donation History",
    transform: "translate(1.9 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10195",
    "data-name": "Path 10195",
    d: "M10.1,11.564v2.064a1.613,1.613,0,0,0,.782,1.3,4.877,4.877,0,0,0,2.7.715,4.877,4.877,0,0,0,2.7-.715,1.613,1.613,0,0,0,.782-1.3V11.564a.454.454,0,1,0-.908,0v2.064c0,.207-.163.376-.386.53a3.968,3.968,0,0,1-2.187.553,3.968,3.968,0,0,1-2.187-.553c-.223-.155-.386-.323-.386-.53V11.564a.454.454,0,1,0-.908,0Z",
    transform: "translate(35.037 34.396)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10196",
    "data-name": "Path 10196",
    d: "M10.1,15.564v2.064a1.613,1.613,0,0,0,.782,1.3,4.877,4.877,0,0,0,2.7.715,4.877,4.877,0,0,0,2.7-.715,1.613,1.613,0,0,0,.782-1.3V15.564a.454.454,0,1,0-.908,0v2.064c0,.207-.163.376-.386.53a3.968,3.968,0,0,1-2.187.553,3.968,3.968,0,0,1-2.187-.553c-.223-.155-.386-.323-.386-.53V15.564a.454.454,0,1,0-.908,0Z",
    transform: "translate(35.037 32.46)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10197",
    "data-name": "Path 10197",
    d: "M13.582,8.1a4.877,4.877,0,0,0-2.7.715,1.614,1.614,0,0,0-.783,1.3,1.614,1.614,0,0,0,.783,1.3,4.877,4.877,0,0,0,2.7.715,4.877,4.877,0,0,0,2.7-.715,1.614,1.614,0,0,0,.783-1.3,1.614,1.614,0,0,0-.783-1.3A4.877,4.877,0,0,0,13.582,8.1Zm0,.929a3.974,3.974,0,0,1,2.187.553c.223.155.386.323.386.53s-.163.375-.386.53a3.974,3.974,0,0,1-2.187.553,3.974,3.974,0,0,1-2.187-.553c-.223-.155-.386-.323-.386-.53s.163-.375.386-.53A3.974,3.974,0,0,1,13.582,9.029Z",
    transform: "translate(35.037 35.848)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10198",
    "data-name": "Path 10198",
    d: "M10.1,11.564v2.064a1.481,1.481,0,0,0,.518,1.085,3.764,3.764,0,0,0,1.867.831.456.456,0,0,0,.527-.376.464.464,0,0,0-.368-.539,3.206,3.206,0,0,1-1.264-.481c-.214-.152-.371-.318-.371-.52V11.564a.454.454,0,1,0-.908,0Z",
    transform: "translate(31 31.548)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10199",
    "data-name": "Path 10199",
    d: "M10.1,12.176V14.24a1.547,1.547,0,0,0,.651,1.2,4.358,4.358,0,0,0,2.29.79.464.464,0,0,0,.076-.926,3.452,3.452,0,0,1-1.807-.6.642.642,0,0,1-.3-.467V12.176a.454.454,0,1,0-.908,0Zm3.011-1a3.448,3.448,0,0,1-1.8-.6.641.641,0,0,1-.3-.466c0-.207.163-.375.386-.53a3.974,3.974,0,0,1,2.187-.553,3.974,3.974,0,0,1,2.187.553c.223.155.386.323.386.53a.454.454,0,1,0,.908,0,1.614,1.614,0,0,0-.783-1.3,4.877,4.877,0,0,0-2.7-.715,4.877,4.877,0,0,0-2.7.715,1.614,1.614,0,0,0-.783,1.3,1.545,1.545,0,0,0,.649,1.2,4.352,4.352,0,0,0,2.285.79.464.464,0,0,0,.077-.925Z",
    transform: "translate(31 33)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalIcon);
export default __webpack_public_path__ + "static/media/externalIcon.85f14d04a38c5fe3bb42a30772e79cf5.svg";
export { ForwardRef as ReactComponent };